import React, { useState, useEffect } from "react";
import {
  Accordion, AccordionSummary, AccordionDetails,
  Typography, TextField, MenuItem
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Autocomplete from "@mui/material/Autocomplete";
import EditItemView from "../common/components/EditItemView";
import { getWithExpiry } from "../common/util/localstorage";

const ShippingPage = () => {
  const [item, setItem] = useState();
  const [produits, setProduits] = useState([]);

  /* -------------------- FETCH PRODUITS -------------------- */

  useEffect(() => {
    const fetchProduits = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_URL_NAME}/products`,
          {
            headers: {
              Authorization: `Bearer ${getWithExpiry("TOKEN")}`,
            },
          }
        );

        if (res.ok) {
          const data = await res.json();
          setProduits(data);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchProduits();
  }, []);

  /* -------------------- VALIDATION -------------------- */

  const validate = () =>
    item && item.produit && item.statut;

  return (
    <EditItemView endpoint="shipping" item={item} setItem={setItem} validate={validate}>
      {item && (
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Shipping</Typography>
          </AccordionSummary>

          <AccordionDetails style={{ display: "flex", flexDirection: "column", gap: 16 }}>

            {/* 🔥 PRODUIT AUTOCOMPLETE */}
            <Autocomplete
              options={produits}
              getOptionLabel={(option) =>
                `${option.reference} | ${option.designation} | ${option.client?.username || "-"}`
              }
              value={
                produits.find((p) => p._id === item.produit) || null
              }
              onChange={(e, newValue) =>
                setItem({ ...item, produit: newValue?._id || "" })
              }
              renderInput={(params) => (
                <TextField {...params} label="Produit" />
              )}
            />

            {/* STATUT */}
            <TextField
              select
              label="Statut"
              value={item.statut || "en_attente"}
              onChange={(e) => setItem({ ...item, statut: e.target.value })}
            >
              {["en_attente", "livre", "retour"].map((s) => (
                <MenuItem key={s} value={s}>{s}</MenuItem>
              ))}
            </TextField>

            {/* COMMENTAIRE */}
            <TextField
              label="Commentaire"
              value={item.commentaire || ""}
              onChange={(e) => setItem({ ...item, commentaire: e.target.value })}
            />

            {/* PAYEE */}
            <TextField
              select
              label="Payée"
              value={String(item.payee ?? false)}
              onChange={(e) =>
                setItem({
                  ...item,
                  payee: e.target.value === "true",
                })
              }
            >
              <MenuItem value="true">Oui</MenuItem>
              <MenuItem value="false">Non</MenuItem>
            </TextField>
          </AccordionDetails>
        </Accordion>
      )}
    </EditItemView>
  );
};

export default ShippingPage;